module.exports = __webpack_public_path__ + "img/external-link.3119a056.svg";